export const API_KEY = "AIzaSyCZMb7GudreMtDU7AvgLGcHiLKeNeYGRx4";

export default API_KEY;